import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  Output
} from '@angular/core';
import { AbstractFormControlComponent } from '../abstract-form-control.component';
import { CheckboxFormControl } from './checkbox-form-control';
import {
  ControlValueAccessor,
  FormGroup,
  NG_VALUE_ACCESSOR
} from '@angular/forms';

@Component({
  standalone: false,
  selector: 'app-checkbox-form-control',
  templateUrl: './checkbox-form-control.component.html',
  styleUrls: ['./checkbox-form-control.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxFormControlComponent),
      multi: true
    }
  ]
})
export class CheckboxFormControlComponent
  extends AbstractFormControlComponent<CheckboxFormControl>
  implements ControlValueAccessor
{
  @Input() override parentForm: FormGroup = new FormGroup({});
  @Input() override formControlName: string = undefined;
  @Input() override title: string = undefined;
  @Input() inline: boolean;
  @Output() onChanged: EventEmitter<boolean> = new EventEmitter();

  onChange: any = (value: string) => {};
  onTouched: any = () => {};

  public registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public writeValue(value: any): void {}

  change(): void {
    this.onChanged.emit(this.control.value);
  }

  public get isInline(): boolean {
    return this.inline || false;
  }
}
